<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="pageTab">
      <span v-for="(p, i) in pages" :key="i" :class="{on: p.name === currentPage}" @click="() => currentPage = p.name" v-text="p.text"></span>
    </div>
    <div class="distributorList" v-show="pages.trial && currentPage === pages.trial.name">
      <div class="topLeft">
        <h3>体验课订单<span class="time">实时更新</span></h3>
        <div class="refresh">手动刷新页面，拉取实时体验课订单数据</div>
      </div>
      <div class="topRight">
        <div>管理员能看到所有成员的订单<br />普通成员只能看到自己的和无归属人的订单<br/>后台数据包含退费订单，实际数据需与对接人确认</div>
      </div>
      <div class="multiteam" v-if="multiteamList.length > 1">
        <el-form :inline="true" label-position="left">
          <el-form-item label="多团队数据查询：">
            <el-select v-model="teamCodeList" filterable placeholder="请选择团队" multiple no-data-text="还没有学期数据">
              <el-option v-for="(team, index) in multiteamList" :key="index" :label="team.abbreviation" :value="team.teamCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="refresh">支持管理员和创建者，查询自己名下的团队数据</div>
      </div>
      <div class="statistics" v-if="statisticsArr.length > 0">
         <li class="card" v-for="(item, index) in statisticsArr" :key='index'>
          <div class="date">{{item.label}}
            <el-tooltip v-if="item.show" class="item" effect="dark" placement="top-start">
              <div slot="content" style="line-height:18px">
                1-订单集合，按照支付时间统计，包括已支付和已退费，不包括未支付。<br />
                2-管理员角色时，包括团队所有成员的订单。<br />
                3-普通成员角色时，只包括归属人是自己的订单，不包括无归属人订单。
              </div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </div>
          <div class="sum">{{numberFormat(item.number)}}</div>
        </li>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="110px" ref="searchForm">
        <el-form-item label="体验课支付状态" prop="order_status">
          <el-select v-model="listQuery.order_status" placeholder="请选择体验课支付状态">
            <el-option
              v-for="item in allOrderStatu"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="payWay" prop="payType">
          <el-select v-model="listQuery.payType" placeholder="请选择支付时间">
            <el-option
              v-for="item in allTime"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="createTime"
            value-format="timestamp"
            type="daterange"
            :picker-options="pickerOptions"
            @blur="enableChoose"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:235px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="课程科目" label-width="80px" prop="subject_type">
          <SubjectCascader v-model="subjectType" :onChange="subjectCascaderChange" :teamCodeList="listQuery.teamCodeList"/>
        </el-form-item>
        <el-form-item label="推广课程" prop="promotion_course_id">
          <el-select v-model="listQuery.promotion_course_id" multiple filterable placeholder="请选择推广课程">
            <el-option label="全部推广课程" value="all" />
            <el-option
              v-for="item in courseList"
              :key="item.id"
              :label="item.agentCourse.name"
              :value="item.agentCourse.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="支付金额" prop="pay_amount">
          <el-input v-model="listQuery.pay_amount" type="number" placeholder="输入支付金额" class="orderStyle" />
        </el-form-item>
        <el-form-item label="推广渠道" prop="promotion_channel_id">
          <el-select v-model="listQuery.promotion_channel_id" filterable placeholder="请选择推广渠道" @change="handleChannel">
            <el-option label="全部推广渠道" :value="null" />
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="`${item.name}-${item.promotionChannelCode}`"
              :value="item.promotionChannelCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广位" prop="promotion_position_id">
          <el-select v-model="listQuery.promotion_position_id" filterable placeholder="请选择推广位">
            <el-option label="全部推广位" :value="null" />
            <el-option
              v-for="item in promotionList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionPositionCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="归属人" prop="member_id">
          <el-select v-model="listQuery.member_id" filterable placeholder="请选择归属人">
            <el-option label="全部归属人" :value="null" />
            <el-option
              v-for="item in teamList"
              :key="item.id"
              :label="item.name"
              :value="item.agentCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="微信昵称" prop="wx_name">
          <el-input v-model="listQuery.wx_name" placeholder="输入微信昵称" class="orderStyle" />
        </el-form-item>
        <el-form-item label="开课日期" label-width="100px" prop="class_open_time">
          <el-date-picker
          v-model="listQuery.class_open_time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="体验课学期" label-width="120px" prop="term_id">
          <el-select
            v-model="listQuery.term_id"
            value-key="id"
            multiple
            filterable
            clearable
            placeholder="请选择学期"
          >
            <el-option label="全部" value='all' />
            <el-option
              v-for="item in termList"
              :key="item.id"
              :label="`${item.id}·${item.name}(${item.description})`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-select v-model="listQuery.grade" multiple filterable placeholder="请选择年级">
            <el-option v-for="key in Object.keys(gradeList)" :key="key" :label="gradeList[key]" :value='key' />
          </el-select>
        </el-form-item>
        <el-form-item label="btc班级" prop="b2c_class_id" v-if="isB2cClassId">
          <el-select v-model="listQuery.b2c_class_id" filterable placeholder="请选择班级">
            <el-option v-for="item in b2cClassList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="学习进度" prop="studyProgress">
          <el-select v-model="listQuery.studyProgress" filterable placeholder="请选择学习进度">
            <el-option :key="0" label="全部" value='all' />
            <el-option :key="1" label="首课未开课" value="1" />
            <el-option :key="2" label="首课已开课" value="2" />
            <el-option :key="3" label="续报未截止" value="3" />
            <el-option :key="4" label="续报已截止" value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID" prop="promotion_link_id">
          <el-input v-model="listQuery.promotion_link_id" placeholder="输入推广链接ID查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="是否重复购买"  v-if="repeatBuy" prop="is_repeat_buy">
          <el-select v-model="listQuery.is_repeat_buy" filterable placeholder="全部">
            <el-option :key="0" label="全部" value='' />
            <el-option :key="1" label="是" :value="1" />
            <el-option :key="2" label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单号" prop="order_no">
          <el-input v-model="listQuery.order_no" placeholder="输入订单号查询" class="orderStyle" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            type="number"
            v-model="listQuery.phone"
            placeholder="输入手机号查询"
            class="orderStyle numrule"
            maxlength="11"
            autocomplete="on"
            @input="checkLength"
            @keyup.native="checkPhoneNumber"
          />
        </el-form-item>
        <el-form-item label="用户ID" prop="user_id">
          <el-input
            v-model="listQuery.user_id"
            placeholder="输入用户ID查询"
            class="orderStyle numrule"
            maxlength="13"
            autocomplete="on"
            @input="checkUserIdLength"
            @keyup.native="checkUserIdNumber"
          />
        </el-form-item>
        <el-form-item label="正课是否续报" v-if="renewShow" prop="is_renew">
          <el-select v-model="listQuery.is_renew" placeholder="请选择">
            <el-option key=0 label="全部" :value=null />
            <el-option key=1 label="是" :value="1" />
            <el-option key=2 label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <!-- 下载组建 -->
        <DownExcel
          :listQuery="listQuery"
          :createTime="createTime"
          :total="total"
          pageType="trial"
        />
      </el-form>
      <el-table v-loading="listLoading" :data="list" :empty-text="emptyText" border fit highlight-current-row style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="团队名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.teamName || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.order_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.pay_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课学期" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.term_id || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像" align="center" width="80">
          <template slot-scope="{row}">
            <img :src="row.wx_avater || '//wxlogo.hetao101.com/default_avatar.png'" alt="avatar" class="avatar" />
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.wx_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.user_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市" align="center" min-width="100" v-if="isMarket">
          <template slot-scope="{row}">
            <span>{{ row.parents_city }}</span>
          </template>
        </el-table-column>
        <el-table-column label="城市等级" align="center" min-width="100" v-if="isMarket">
          <template slot-scope="{row}">
            <span>{{ row.parents_city_level }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否加微" align="center" min-width="100" v-if="isMarket && isAddedCounselorWx">
          <template slot-scope="{row}">
            <span>{{ (row.is_added_counselor_wx ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否关注公众号" align="center" min-width="100" v-if="isMarket && isSubscribe">
          <template slot-scope="{row}">
            <span>{{ (row.is_subscribe ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否首课到课" align="center" min-width="100" v-if="isMarket && isUnit1Attend">
          <template slot-scope="{row}">
            <span>{{ (row.is_unit1_attend ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="btc班级" align="center" min-width="100" v-if="isB2cClassId">
          <template slot-scope="{row}">
            <span>{{ row.b2c_class_id ? `${row.b2c_class_id}班` : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="btc学校" align="center" min-width="160" :show-overflow-tooltip="true" v-if="isMarket && isB2cSchoolId">
          <template slot-scope="{row}">
            <span>{{ row.b2c_school_name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年级" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ gradeList[row.grade] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="首课进度" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.is_unlock === 1 ? '首课未开课' : row.is_unlock === 0 ? '首课已开课' : ''  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开课日期" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.class_open_time || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="续报进度" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.is_renewal === 1 ? '续报未截止' : row.is_renewal === 0 ? '续报已截止' : ''  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="体验课支付状态" align="center" min-width="90">
          <template slot-scope="{row}">
            <span>{{ handleStatus(row.order_status) || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否重复购买" align="center" min-width="115"  v-if="repeatBuy">
          <template slot-scope="{row}">
            <span>{{ (row.is_repeat_buy ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="课程科目" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.subject_type || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.promotion_course_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程ID" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.promotion_course_id || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{ row.order_no || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" align="center" min-width="200">
          <template slot-scope="{row}">
            <span>{{  row.order_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="归属人" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.member_name || '无归属人' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广链接ID" align="center" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.promotion_link_id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广渠道" width="180px">
          <template slot-scope="{row}">
            <el-tooltip class="item" effect="dark" :content="row.promotion_channel_name" placement="top">
              <span>{{ row.promotion_channel_name && row.promotion_channel_name.length > 10 ? `${row.promotion_channel_name.slice(0, 10)}...` : row.promotion_channel_name || '--' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="推广位" align="center" min-width="140">
          <template slot-scope="{row}">
            <span>{{ row.promotion_position_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="正课是否续报" align="center" width="100" v-if="renewShow">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="续报数据延迟一天，今天只能看到昨天续报的" placement="top">
              <span class="icon-question">正课是否续报</span>
            </el-tooltip>
          </template>
          <template slot-scope="{row}">
            <span>{{ row.is_renew == 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="续报时间" align="center" width="160" v-if="renewShow">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="续报实际发生的时间" placement="top">
              <span class="icon-question">续报时间</span>
            </el-tooltip>
          </template>
          <template slot-scope="{row}">
            <span>{{ row.renew_time ? timestampToDate(row.renew_time) : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="续报是否退费" align="center" min-width="140" v-if="isMarket && refundShow">
          <template slot-scope="{row}">
            <span>{{ (row.is_renewal_refund ? '是' : '否') || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" min-width="140" v-if="isMarket && refundShow">
          <template slot-scope="{row}">
            <span>{{ (row.is_oa_judge ? '多笔L1订单' : '-') || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.index"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <div class="distributorList" v-show="pages.importOrder && currentPage === pages.importOrder.name" >
      <ImportOrder></ImportOrder>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { mapGetters } from 'vuex'
import Pagination from "@/components/Pagination/index";
import DownExcel from "@/components/DownExcel/index";
import SubjectCascader from "@/components/SubjectCascader";
import ImportOrder from "./ImportOrder.vue"
import { getTermListNew } from "@/services/term";
import { getOrderList, getStatistics, getCourseList, getDorisTime } from "@/services/order";
import { getChannelList, getTeamList } from "@/services/link";
import { getPromotionList } from "@/services/promotion";
import { apiGetB2CClassList } from "@/services/b2cStatement";
import PowerWrapper from "@/components/PowerWrapper";
import { timestampToDate, delUndefined, numFormat, timestampToDateTotal } from "@/utils/utils";
import { getAgentCode, getTeamCode, getTeamRole, isMarket } from '@/utils/auth'

const teamRole = Number(getTeamRole());
const manager = teamRole === 1 || teamRole === 2;

export default {
  name: "order",
  components: {
    Pagination,
    PowerWrapper,
    DownExcel,
    SubjectCascader,
    ImportOrder,
  },
  data() {
    return {
      CurrRole: "order",
      list: [],
      termList: [], // 学期array
      subjectType: [],
      multiteamList: [],
      teamCodeList: [],
      currentPage: 'trial',
      isMarket: isMarket(),
      dorisTime: '',
      pages: {
        trial: {
          name: 'trial',
          text: '体验课订单'
        }
      },
      gradeList: {
        1: '一年级',
        2: '二年级',
        3: '三年级',
        4: '四年级',
        5: '五年级',
        6: '六年级',
        7: '幼儿中班',
        8: '幼儿大班',
        11: '初一',
        12: '初二',
        13: '初三',
      },
      emptyText: '暂无数据',
      listQuery: {
        index: 1,
        pageSize: 10,
        subject_type: [],
        class_open_time: '',
        orderStatus: null,
        renew: null,
        payType: 'payTime',
        courseId: null,
        channelCode: null,
        positionCode: null,
        belongerCode: manager ? null : getAgentCode(),
        wxName: null,
        orderNumber: null,
        linkCode: null,
        is_repeat_buy: '',
        term_id: null,
        studyProgress: null,
        mobile: null,
        grade: [],
        user_id: null,
        pay_amount: null,
        promotion_course_id: [],
        teamCodeList: '',
        promotion_channel_id: '',
        promotion_position_id: '',
        order_status: 'PAID',
        member_id: '',
        wx_name: '',
        promotion_link_id: '',
        phone: '',
        is_renew: '',
        order_no: '',
        b2c_class_id: undefined,
      },
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const day1 = 730 * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      },
      total: 1,
      allOrderStatu: [
        {
          value: null,
          name: '全部'
        },
        {
          value: 'PAID',
          name: '已支付'
        },
        {
          value: 'UNPAID',
          name: '未支付'
        },
        {
          value: 'REFUND',
          name: '已退费'
        }
      ],
      allTime: [
        {
          value: 'payTime',
          name: '支付时间'
        },
        {
          value: 'orderTime',
          name: '下单时间'
        }
      ],
      listLoading: false,
      statisticsArr: [],
      courseList: [],
      channelList: [],
      promotionList: [],
      teamList: [],
      b2cClassList: [],
      updateTime: null
    };
  },
  computed: {
    ...mapGetters([
      'renewShow',
      'repeatBuy',
      'manualOrder',
      'loginInfos',
      'isSubscribe',
      'isAddedCounselorWx',
      'isUnit1Attend',
      'isB2cClassId',
      'isB2cSchoolId',
      'refundShow',
    ]),
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getList()
    // 统计接口
    this.getStatistics()
    // 获取推广课程
    this.getCourseList()
    // 获取推广渠道
    this.getChannelList()
    // 获取团队成员信息
    this.getTeamList()
    // 获取学期列表
    this.getTermList()
    // 获取数据更新时间
    this.getDorisTime()
    this.getB2CClassList()
    // 多团队数据查询
    if (manager) this.getMultiteamList()
  },
  watch: {
    manualOrder: {
      handler(val) {
        this.setTab(val);
      }
    }
  },
  mounted() {
    this.setTab(this.manualOrder);
  },
  methods: {
    getMultiteamList() {
      const { loginInfos } = this;
      if (loginInfos && loginInfos.length > 0) {
        this.multiteamList = loginInfos.filter(item => item.teamRole > 0 && item.teamType === 1);
        console.log('list ', this.multiteamList, loginInfos);
      }
    },
    handleQuery() {
      const teamCode = this.teamCodeList.join(',');
      this.$refs.searchForm.resetFields();
      this.listQuery.teamCodeList = teamCode;
      this.subjectType = [];
      this.listQuery.subject_type = [];
      this.getList();
      this.getStatistics();
      this.getCourseList();
      this.getChannelList();
      this.getTeamList();
      this.getTermList();
    },
    subjectCascaderChange(subject_type) {
      this.listQuery.subject_type = subject_type;
    },
    setTab(isManualOrder) {
      if (isManualOrder) {
        const importOrder = {
          name: 'importOrder',
          text: '手动导入订单'
        }
        Object.assign(this.pages, { importOrder });
      }
    },
    checkLength (e) {
      if (e.length > 11) {
        this.listQuery.mobile = e.slice(0, 11)
      }
    },
    checkPhoneNumber() {
      const regNum = /[^\d]/g;
      this.listQuery.mobile = this.listQuery.mobile && regNum.test(this.listQuery.mobile) ? this.listQuery.mobile.toString().replace(/[^\d]/g, '') : this.listQuery.mobile;
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    getTermList() {
      const params = {
        teamCodeList: this.listQuery.teamCodeList,
      }
      getTermListNew(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data;
        } else {
          this.termList = [];
        }
      });
    },
    getB2CClassList() {
      apiGetB2CClassList().then(res => {
        console.log('getB2CClassList ', res)
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.b2cClassList = res.data.data;
        } else {
          this.b2cClassList = [];
        }
      });
    },
    getDorisTime() {
      getDorisTime().then(res => {
        console.log('getdorisTime ', res)
        const { lastUpdateTime } = res.data || {}
        this.dorisTime = lastUpdateTime;
      });
    },
    getStatistics() {
      this.updateTime = Date.parse(new Date());
      const params = {
        teamCodeList: this.listQuery.teamCodeList,
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      getStatistics(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          const orderList = res.data.data;
          if (orderList && orderList.length > 0) {
            this.statisticsArr = orderList.map(element => {
              if (element && element.timeType) {
                return {
                  label: element.timeType === 'today' ? '今日订单量'
                    : element.timeType === 'week' ? '本周订单量'
                      : element.timeType === 'month' ? '本月订单量'
                        : element.timeType === 'total' ? '累计订单总量' : '',
                  number: element.number || 0,
                  show: element.timeType === 'today'
                }
              }
            });
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.statisticsArr = [];
        }
      });
    },
    getList(btnName) {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (query === 'all') {
          delete _listQuery[key]
        } else if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        }
      });
      const { payType, grade, term_id, promotion_course_id } = _listQuery;
      const params = {
        orderType: 'desc',
        orderColumn: 'order_time',
        ..._listQuery,
        index: btnName === 'search' ? 1 : this.listQuery.index,
        grade: grade && grade.join(','),
        promotion_course_id: Array.isArray(promotion_course_id) ? promotion_course_id.join(',') : null,
        term_id: Array.isArray(term_id) ? term_id.join(',') : null,
        start_pay_time: payType === 'payTime' && createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_pay_time: payType === 'payTime' && createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        start_order_time: payType === 'orderTime' && createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_order_time: payType === 'orderTime' && createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        agentCode: getAgentCode()
      }
      delete params.payType;
      getOrderList({
        type: 'POST',
        params: {
          ...delUndefined(params)
        }
      }).then((res = {}) => {
        const { errCode, errMsg, data, total } = res.data || {};
        if (errCode === 0 && Array.isArray(data) && data.length > 0) {
          this.listLoading = false;
          this.list = data;
          this.total = total;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.emptyText = errMsg && errMsg !== 'success' ? errMsg : '暂无数据';
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
    },
    getPromotionList(channelCode) {
      const params = {
        teamCode: getTeamCode(),
        teamCodeList: this.listQuery.teamCodeList,
        channelCode: channelCode,
      }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.promotionList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.promotionList = [];
        }
      });
    },
    getTeamList() {
      const params = {
        teamCode: getTeamCode(),
        teamCodeList: this.listQuery.teamCodeList,
      }
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          let teamArr = []
          // 角色身份
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr.concat(res.data.data);
          } else {
            teamArr = [
              {
                agentCode: getAgentCode(),
                name: '我的'
              },
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr;
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.teamList = [];
        }
      });
    },
    getCourseList() {
      getCourseList(this.listQuery.teamCodeList).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.courseList = res.data.data.list;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.courseList = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode, this.listQuery.teamCodeList).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    handleChannel(value) {
      this.channelCode = value;
      this.listQuery.positionCode = null;
      if (value) {
        this.getPromotionList(value)
      } else {
        this.promotionList = [];
      }
    },
    handleSearch() {
      this.getList('search');
    },
    checkUserIdLength (e) {
      if (e.length > 13) {
        this.listQuery.user_id = e.slice(0, 13)
      }
    },
    checkUserIdNumber() {
      const regNum = /[^\d]/g;
      this.listQuery.user_id = this.listQuery.user_id && regNum.test(this.listQuery.user_id) ? this.listQuery.user_id.toString().replace(/[^\d]/g, '') : this.listQuery.user_id;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.icon-question{
  cursor: pointer;
}
.multiteam {
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
